import * as Api from '@ViewModels';
import { useEmailLikeStepState } from './useEmailLikeStepState';

interface UseHtmlNewsletterStepStateProps {
	newsletterStep: Api.IHtmlNewsletterAutomationStep | null;
	template: Api.IAutomationTemplate | null;
	stepId: string;
	readonly: boolean;
	onSaveSuccess?: () => void;
	onSaveError?: (error: Api.IOperationResultNoValue) => void;
}

/**
 * State management hook for HtmlNewsletterStepRenderer.
 * Delegates to the shared useEmailLikeStepState hook.
 */
export function useHtmlNewsletterStepState({
	newsletterStep,
	template,
	stepId,
	readonly,
	onSaveSuccess,
	onSaveError,
}: UseHtmlNewsletterStepStateProps) {
	return useEmailLikeStepState({
		step: newsletterStep as (Api.IEmailAutomationStep & Api.IHtmlNewsletterAutomationStep) | null,
		template,
		stepId,
		readonly,
		onSaveSuccess,
		onSaveError,
	});
}
